@if (showButton) {
<button class="jump-to-top" (click)="scrollToTop()">
  <mat-icon>arrow_upward</mat-icon>
</button>
}
